import { useState } from "react";

import AppleStoreActive from "~/modules/Router/Browser/assets/AppleStore-Active.png";
import AppleStore from "~/modules/Router/Browser/assets/AppleStore.png";
import ChromeActive from "~/modules/Router/Browser/assets/Chrome-Active.png";
import Chrome from "~/modules/Router/Browser/assets/Chrome.png";
import Cody from "~/modules/Router/Browser/assets/Cody1.png";
import Comma from "~/modules/Router/Browser/assets/Comma1.png";
import GooglePlayActive from "~/modules/Router/Browser/assets/GooglePlay-Active.png";
import GooglePlay from "~/modules/Router/Browser/assets/GooglePlay.png";
import Logo from "~/modules/Router/Browser/assets/Logo.png";
import Sorry from "~/modules/Router/Browser/assets/Sorry.png";

const BUTTON_LINK = {
  chrome: "https://www.google.com/chrome/",
  googlePlay:
    "https://play.google.com/store/apps/details?id=com.ciety.xyz.prod&pli=1",
  appleStore:
    "https://apps.apple.com/us/app/ciety-web3-game-community/id6443814305",
};

export const BrowserNotSupported = () => {
  const [isChromeButtonHovered, setIsChromeButtonHovered] =
    useState<boolean>(false);
  const [isGooglePlayButtonHovered, setIsGooglePlayButtonHovered] =
    useState<boolean>(false);
  const [isAppStoreButtonHovered, setIsAppStoreButtonHovered] =
    useState<boolean>(false);

  return (
    <div className="h-screen w-full bg-ciety-dk">
      <img
        className="absolute left-[1.875rem] top-[1.875rem] h-auto w-[10.305rem]"
        alt="CIETY"
        src={Logo}
      />
      <div className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 flex-col items-center gap-y-10">
        <img
          className="h-auto w-[25rem]"
          alt="Sorry, this web browser is not supported. Your world is open to PC Chrome browser. Get the app on your mobile phone too."
          src={Sorry}
        />
        <div className="flex w-full flex-col items-center gap-y-10">
          <a
            href={BUTTON_LINK.chrome}
            target="_blank"
            className="flex-center h-[3.75rem] w-[16.813rem] rounded-[1rem] border border-ciety-bk bg-ciety-lg transition-all hover:border-ciety-lg hover:bg-ciety-dk"
            onMouseEnter={() => {
              setIsChromeButtonHovered(true);
            }}
            onMouseLeave={() => {
              setIsChromeButtonHovered(false);
            }}
          >
            <img
              className="h-[1.5rem] w-auto"
              alt="Download Chrome Browser"
              src={isChromeButtonHovered ? ChromeActive : Chrome}
            />
          </a>
          <div className="flex gap-x-[1.125rem]">
            <a
              href={BUTTON_LINK.googlePlay}
              target="_blank"
              className="flex-center hover-border-ciety-dk h-[3.75rem] w-[15rem] rounded-[1rem] border border-ciety-lg bg-ciety-dk transition-all hover:bg-ciety-lg"
              onMouseEnter={() => {
                setIsGooglePlayButtonHovered(true);
              }}
              onMouseLeave={() => {
                setIsGooglePlayButtonHovered(false);
              }}
            >
              <img
                className="h-[1.5rem] w-auto"
                alt="Download on Google Play"
                src={isGooglePlayButtonHovered ? GooglePlayActive : GooglePlay}
              />
            </a>
            <a
              href={BUTTON_LINK.appleStore}
              target="_blank"
              className="flex-center hover-border-ciety-dk h-[3.75rem] w-[15rem] rounded-[1rem] border border-ciety-lg bg-ciety-dk transition-all hover:bg-ciety-lg"
              onMouseEnter={() => {
                setIsAppStoreButtonHovered(true);
              }}
              onMouseLeave={() => {
                setIsAppStoreButtonHovered(false);
              }}
            >
              <img
                className="h-[1.5rem] w-auto"
                alt="Download on App Store"
                src={isAppStoreButtonHovered ? AppleStoreActive : AppleStore}
              />
            </a>
          </div>
        </div>
      </div>
      <img
        className="absolute bottom-0 left-0 max-h-[80%] max-w-[40%]"
        alt="Comma"
        src={Comma}
      />
      <img
        className="absolute bottom-0 right-0 max-h-[100%] max-w-[40%]"
        alt="Cody"
        src={Cody}
      />
    </div>
  );
};
